import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/HiringPage";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";
import { insights_helper } from "@/helpers/insights_helper";
import sourceflowEnums from "@/sourceflow.enums";
import { toInsightCardItems } from "@/functions/toInsightCardItems";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const insights = toInsightCardItems(insights_helper.filter((i) => ("tags" in i ? i?.tags?.includes("Hiring") : false)));

  const routerProp = router["hiring"];
  const titleKey = "page.hiring.banner.title";

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [
        { component: "HiringPageBannerSection", props: { className: "" } },
        { component: "HiringPageContentSection", props: { className: "py-4 py-md-5" } },
        {
          component: "ValuesSection",
          props: { className: "py-4 py-md-5", title: { path: "page.hiring.values.title" }, tags: "Hiring" },
        },
        { component: "HiringPageDeliverSection", props: { className: "py-4 py-md-5" } },
        { component: "SolutionsSection", props: { className: "py-4 py-md-5" } },
        { component: "StatisticsSection", props: { className: "py-4 py-md-5" } },
        {
          component: "InsightsSection",
          props: {
            className: "py-4 py-md-5",
            title: { path: "page.hiring.insights.title" },
            items: insights,
          },
        },
        { component: "AwardsSection", props: { className: "py-4 py-md-5" } },
      ],
    },
  };
}
